"use client"

import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import "./Home.css"

const Home = ({ language }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const translations = {
    en: {
      heroTitle: "BICHI FIRST",
      heroSubtitle: "Hon. Abubakar Kabir Abubakar",
      heroDescription:
        "Member Representing Bichi Federal Constituency & Chairman House of Representatives Committee on Appropriations",
      projectsCount: "50+",
      projectsLabel: "Constituency Projects",
      budgetAmount: "₦1.6T",
      budgetLabel: "Budget Oversight",
      yearsService: "6+",
      yearsLabel: "Years of Service",
      beneficiaries: "10,000+",
      beneficiariesLabel: "Direct Beneficiaries",
      overviewTitle: "Transforming Bichi Through Leadership",
      overviewDescription:
        "Dedicated to serving the people of Bichi Federal Constituency with transparency, accountability, and unwavering commitment to development. From infrastructure projects to educational scholarships, we are building a better future together.",
      aboutTitle: "About AKA Bichi",
      aboutDescription: "Learn about the journey, vision, and achievements of Hon. Abubakar Kabir Abubakar.",
      projectsTitle: "Constituency Projects",
      projectsDescription: "Discover the transformative projects bringing development to Bichi communities.",
      legislativeTitle: "Legislative Work",
      legislativeDescription: "Explore the national impact through the House Committee on Appropriations.",
      awardsTitle: "Awards & Recognition",
      awardsDescription: "Celebrating excellence in democratic leadership and community service.",
      ctaTitle: "Get Involved",
      ctaDescription: "Join us in building a stronger, more prosperous Bichi Federal Constituency.",
      ctaButton: "Contact Us",
    },
    ha: {
      heroTitle: "BICHI FARKO",
      heroSubtitle: "Malam Abubakar Kabir Abubakar",
      heroDescription: "Wakilin Mazabar Bichi da Shugaban Kwamitin Kasafin Kudi na Majalisar Wakilai",
      projectsCount: "50+",
      projectsLabel: "Ayyukan Mazaba",
      budgetAmount: "₦1.6T",
      budgetLabel: "Kulawar Kasafin Kudi",
      yearsService: "6+",
      yearsLabel: "Shekarun Hidima",
      beneficiaries: "10,000+",
      beneficiariesLabel: "Masu Cin Gajiyar Kai Tsaye",
      overviewTitle: "Canza Bichi Ta Hanyar Jagoranci",
      overviewDescription:
        "Sadaukarwa ga hidimar mutanen Mazabar Bichi da gaskiya, lissafi, da jajircewa ga ci gaba. Daga ayyukan gine-gine zuwa tallafin ilimi, muna gina makomar gaba tare.",
      aboutTitle: "Game da AKA Bichi",
      aboutDescription: "Koyi game da tafiya, hangen nesa, da nasarorin Malam Abubakar Kabir Abubakar.",
      projectsTitle: "Ayyukan Mazaba",
      projectsDescription: "Gano ayyukan canza da ke kawo ci gaba ga al'ummomin Bichi.",
      legislativeTitle: "Aikin Majalisa",
      legislativeDescription: "Bincika tasirin kasa ta hanyar Kwamitin Kasafin Kudi na Majalisar Wakilai.",
      awardsTitle: "Kyaututtuka da Karramawa",
      awardsDescription: "Murnar nagarta a jagorancin dimokuradiyya da hidimar al'umma.",
      ctaTitle: "Shiga Cikin Aiki",
      ctaDescription: "Ku shiga tare da mu wajen gina Mazabar Bichi mai karfi da wadata.",
      ctaButton: "Tuntuɓar Mu",
    },
  }

  const t = translations[language]

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <img
          src="/images/homepic.jpeg"
          alt="Hon. Abubakar Kabir Abubakar addressing constituents"
          className={`hero-image ${isVisible ? "fade-in" : ""}`}
        />
        <div className={`hero-content ${isVisible ? "slide-in-up" : ""}`}>
          <h1 className="hero-title">{t.heroTitle}</h1>
          <h2 className="hero-subtitle">{t.heroSubtitle}</h2>
          <p className="hero-description">{t.heroDescription}</p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className={`stats-container ${isVisible ? "slide-in-up" : ""}`}>
          <div className="stat-card">
            <div className="stat-number">{t.projectsCount}</div>
            <div className="stat-label">{t.projectsLabel}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{t.budgetAmount}</div>
            <div className="stat-label">{t.budgetLabel}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{t.yearsService}</div>
            <div className="stat-label">{t.yearsLabel}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{t.beneficiaries}</div>
            <div className="stat-label">{t.beneficiariesLabel}</div>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="overview-section">
        <div className="overview-content">
          <h2 className={`section-title ${isVisible ? "slide-in-left" : ""}`}>{t.overviewTitle}</h2>
          <p className={`section-description ${isVisible ? "slide-in-right" : ""}`}>{t.overviewDescription}</p>

          <div className={`quick-links ${isVisible ? "slide-in-up" : ""}`}>
            <Link to="/about" className="link-card">
              <h3>{t.aboutTitle}</h3>
              <p>{t.aboutDescription}</p>
            </Link>
            <Link to="/projects" className="link-card">
              <h3>{t.projectsTitle}</h3>
              <p>{t.projectsDescription}</p>
            </Link>
            <Link to="/legislative" className="link-card">
              <h3>{t.legislativeTitle}</h3>
              <p>{t.legislativeDescription}</p>
            </Link>
            <Link to="/awards" className="link-card">
              <h3>{t.awardsTitle}</h3>
              <p>{t.awardsDescription}</p>
            </Link>
          </div>
        </div>
      </section>

    </div>
  )
}

export default Home
